import localhost from "apis/localhost";
import { STATUS } from "constants/routes";
import { showErrorModal } from "slices/app/actions/error";
import {
  addToJobQueue,
  clearJobQueue,
  removeFromJobQueue,
  setActionRequired,
} from "slices/app/appSlice";
import {
  fetchCategories,
  fetchDocument,
} from "slices/dictionarySearch/actions/categories";

const FULL_REANALYZE_HTTP_STATUS = 202;

export const refreshView =
  (isFolderLevel, by, folderId, documentId, navigate) =>
  async (dispatch, _getState) => {
    dispatch(setActionRequired({}));
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .post("/dictionarySearch/folder/refreshStats", null, {
        params: { folderId },
      })
      .then(async (response) => {
        dispatch(removeFromJobQueue("genericJob"));
        if (response?.status === FULL_REANALYZE_HTTP_STATUS && navigate) {
          navigate(STATUS);
          return;
        }
        if (isFolderLevel) {
          dispatch(fetchCategories(by, folderId, navigate));
        } else {
          dispatch(fetchDocument(folderId, documentId, navigate));
        }
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
        dispatch(clearJobQueue());
      });
  };
